import $ from "jquery";

export const teamBox = function () {
	if (!($(".js-team-item").length > 0)) return false;

	const $elms = {
		teamToggle: $(".js-team-toggle"),
		roleInfoBtn: $(".js-role"),
		roleCardPopup: $(".js-role-card-popup"),
		roleCardPopupClose: $(".js-role-card-popup-close"),
	};

    $elms.teamToggle.on("click", function () {
        const $this = $(this);
        const $teamBox = $this.parent();
        const hasOpened = $teamBox.hasClass("is-active");
        const isOpen = !hasOpened;
        
        $teamBox.siblings().removeClass("is-active");
        
        $teamBox.toggleClass("is-active", isOpen);
    })

	$elms.roleInfoBtn.on("click", function () {
        const windowScrollTop = $(window).scrollTop();
        const parentH = $(this).parents(".team__chart").outerHeight()/2;
        const parentY = $(this).parents(".team__chart").offset().top;
		const learningGoalId = $(this).attr("data-learning-goal-id");
		const learningGoalColor = $(this).attr("data-color");
		$elms.roleCardPopup.removeClass("is-active");
		$elms.roleCardPopup
			.filter(`[data-learning-goal-id="${learningGoalId}"]`)
			.css({
                "background-color":learningGoalColor,
                "top":(parentY+parentH)-windowScrollTop
            })
			.addClass("is-active");
	});

	$elms.roleCardPopupClose.on("click", function () {
		$elms.roleCardPopup.removeClass("is-active");
	});
	

};